import React from 'react';
import styled from 'styled-components';

const RATING_COLORS = ['#e63939', '#ff4d40', '#c36eff', '#538cff', '#53b7ff', '#1ed931'];

const RATING_GRADIENT = `linear-gradient(to top, ${RATING_COLORS.join(', ')})`;

const StaticSliderStyle = styled.div`
    display: block;
    box-sizing: border-box;
    position: relative;
    width: 18px;
    height: 135px;
    border-radius: 40px;
    z-index: 2;
`;

const StaticSliderTrack = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${RATING_GRADIENT};
    border-radius: 10px;
`;

const StaticSliderThumb = styled.div<{ position: number }>`
    position: absolute;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #eee;
    top: ${props => `calc(${1 - (props.position - 1) / 99} * (100% - 10px) - 7.5px)`};
    z-index: 2;
    
    &::after {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        border-radius: 50%;
        background-color: white;
    }
`;

const StaticSliderMajority = styled.div<{ position: number }>`
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #FFF;
    top: ${props => `calc(${1 - (props.position - 1) / 99} * (100% - 10px) - 7.5px)`};
    z-index: 1;
    background: transparent;
    
    &::after {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        border-radius: 50%;
        background: transparent;
    }
`;


const RatingMark = styled.div`
    position: absolute;
    color: white;
    font-size: 12px;
    font-weight: bold;
    
    &.top {
        top: -27px;
        left: 2px;
    }
    
    &.bottom {
        bottom: -19px;
        left: 1.5px;
    }
`;

const ThumbColorIndicator = styled.div<{ position: number }>`
    background: ${RATING_GRADIENT};
    width: 24px;
    height: 24px;
    border-radius: 50%; 
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    background-size: 100% 135px;
    background-position: center calc(100% - ${props => ((props.position - 1) / 99) * 100}%);
`;

const ReferenceLine = styled.div<{ position: number; color: string; show: boolean }>`
    position: absolute;
    height: 8px;
    width: 21px;
    background-color: ${props => props.color};
    top: ${props => `calc(${1 - (props.position - 1) / 99} * (100% - 10px) - 3px)`};
    left: 18px;
    z-index: -1;
    opacity: ${props => props.show ? 1 : 0};
    transition: opacity 0.2s ease;
`;

interface StaticSliderProps {
    userRating: number;
    majorityRating?: number | null;
    showReferenceLine?: boolean;
    referenceLineColor?: string;
    hideSlider?: boolean; // Hides slider but keeps space for BetterSlider
}

const StaticSlider: React.FC<StaticSliderProps> = ({ userRating, majorityRating, showReferenceLine = false, referenceLineColor = '#000000', hideSlider = false }) => {
    
    return (
        <>
            <StaticSliderStyle style={{ opacity: hideSlider ? 0 : 1 }}>
                <StaticSliderTrack />
                <StaticSliderThumb position={userRating}>
                    <ThumbColorIndicator position={userRating} />
                </StaticSliderThumb>
                {majorityRating && (
                    <StaticSliderMajority position={majorityRating} />
                )}
                {majorityRating && showReferenceLine && (
                    <ReferenceLine 
                        position={majorityRating} 
                        color={referenceLineColor}
                        show={showReferenceLine}
                    />
                )}
                <RatingMark className="top">10</RatingMark>
                <RatingMark className="bottom">0.1</RatingMark>
            </StaticSliderStyle>
        </>
    );
};

export default StaticSlider;